'use client';

import './sider-left.scss';
import {useRef} from "react";
import { useContentSize } from "@/components/SizeProvider";
import Intro from "./Intro";
import LoadingCapabilities from "./LoadingCapabilities"
import Processing from "./Processing";
import { useIsSafari } from '@/lib/hooks/useIsSafari';

const SiderLeft = () => {
  const ref = useRef<HTMLDivElement>(null)
  const { width: widthContent, height: heightContent } = useContentSize();
  const width = (widthContent - (heightContent * 16 / 15 + 160)) / 2;
  const isSafari = useIsSafari();

  return (
    <div ref={ref} className={'sider-left'} style={{
      width: width,
      fontSize: widthContent / 180, // was 160
      height: heightContent * 0.8,
      fontWeight: isSafari ? 500 : 700
    }}>
      <Intro/>
      <LoadingCapabilities/>
      <Processing/>
    </div>
  )
};

export default SiderLeft;